module.exports = __webpack_public_path__ + "img/star.eade1701.svg";